import { Injectable } from '@angular/core';
import { Http, Response, RequestOptions, Headers   } from '@angular/http';
import 'rxjs/add/operator/catch';
import { Observable }     from 'rxjs/Observable';


import { ServiciosEspeciales } from '../model/servicios-especiales';

import { SERVICIOS } from '../services/testing/mock-servicio-especial';
import { UtilitiesService } from '../services/utilities.service';

@Injectable()
export class ServicioEspecialService {

  constructor(
    private _http:Http,
    private _utilities:UtilitiesService

  ) { }
 
 getServicios(query:any) : Observable<ServiciosEspeciales[]> {
         
    let json = {   "Metodo": "getCobroServiciosListado",   "Datos":  query};

    let params = "Data="+ this._utilities.getEscapeString(JSON.stringify(json));

		let headers = new Headers({'Content-Type':'application/x-www-form-urlencoded'});

    return this._http.post(this._utilities.getURL("get"), 
				params, {headers: headers}).map(res => res.json());       
 
  } 

  getCobrosDocumento(query:any) : Observable<ServiciosEspeciales[]> {
         
    let json = {   "Metodo": "getCobroServicioListadoDocumento",   "Datos":  query};

    let params = "Data="+ this._utilities.getEscapeString(JSON.stringify(json));

		let headers = new Headers({'Content-Type':'application/x-www-form-urlencoded'});

    return this._http.post(this._utilities.getURL("get"), 
				params, {headers: headers}).map(res => res.json());       
 
  } 


  
 public insert(cobro: ServiciosEspeciales){
   
    let json = {   "Metodo": "postServicioEspecialCobro",   "Datos": cobro  };

    let params = "Data="+ this._utilities.getEscapeString(JSON.stringify(json));

		let headers = new Headers({'Content-Type':'application/x-www-form-urlencoded'});

		return this._http.post(this._utilities.getURL("post"), 
				params, {headers: headers}).map(res => res.json());
}


public delete(cobro: ServiciosEspeciales){
   
  let json = {   "Metodo": "postDeleteServicioEspecialCobro",   "Datos": cobro  };

  let params = "Data="+ this._utilities.getEscapeString(JSON.stringify(json));

  let headers = new Headers({'Content-Type':'application/x-www-form-urlencoded'});

  return this._http.post(this._utilities.getURL("post"), 
      params, {headers: headers}).map(res => res.json());
}


}



// WEBPACK FOOTER //
// D:/Proyectos/tpl viejo prueba/eflowTPL/src/app/services/servicio-especial.service.ts